import React, { createContext, useCallback, useContext, useState } from 'react';

const HoverNavigationContext = createContext();

export function HoverNavigationProvider({ children }) {
    const [active, setActive] = useState(false);

    const toggle = useCallback(() => setActive((prev) => !prev), []);

    return (
        <HoverNavigationContext.Provider value={{ active, toggle }}>
            {children}
        </HoverNavigationContext.Provider>
    );
}

export function useHoverNavigationContext() {
    return useContext(HoverNavigationContext);
}
